// ============================================================================
// SEED / DEMO JOBS
// Placeholder job listings so the Job Board isn't empty while real jobs are
// posted. Same pattern as seedMembers/seedGroups: `isSeed: true`, `seed-job-*`
// ids, all in one file. Admin can hide ALL demo content via the dashboard
// "Hide demo content" toggle. Delete entries here as real jobs come in.
// ============================================================================

export const SEED_JOBS = [
  {
    id: 'seed-job-1', isSeed: true,
    title: 'M&A Associate',
    company: 'Goldman Sachs', companyType: 'Investment Bank',
    location: 'New York, NY', type: 'Full-time',
    salary: '$175,000 - $225,000',
    description: 'Execute buy- and sell-side M&A transactions across technology and industrials. Build financial models, manage due diligence, and support senior bankers through close.',
    requirements: ['2-4 years of investment banking experience', 'Strong financial modeling skills', 'CFA a plus'],
    contactEmail: 'careers@example.com',
    featured: true, status: 'open', postedBy: 'seed', postedDate: '2026-06-10',
  },
  {
    id: 'seed-job-2', isSeed: true,
    title: 'Private Equity Analyst',
    company: 'Blackstone', companyType: 'Private Equity',
    location: 'New York, NY', type: 'Full-time',
    salary: '$150,000 - $190,000',
    description: 'Evaluate buyout opportunities across consumer and healthcare. Support diligence, modeling, and portfolio monitoring.',
    requirements: ['1-3 years in IB or PE', 'LBO modeling', 'Strong analytical skills'],
    contactEmail: 'careers@example.com',
    featured: false, status: 'open', postedBy: 'seed', postedDate: '2026-06-12',
  },
  {
    id: 'seed-job-3', isSeed: true,
    title: 'Corporate Development Manager',
    company: 'Morgan Stanley', companyType: 'Investment Bank',
    location: 'Chicago, IL', type: 'Full-time',
    salary: '$160,000 - $200,000',
    description: 'Lead inorganic growth initiatives: pipeline development, valuation, negotiation, and post-merger integration.',
    requirements: ['4+ years in IB, PE, or corporate development', 'M&A execution experience'],
    contactEmail: 'careers@example.com',
    featured: false, status: 'open', postedBy: 'seed', postedDate: '2026-06-14',
  },
];
